import { PlumbingLicence } from '../types/cover';
import { ClauseWording } from '../types/policy';

export const parsePlumbingLicences = (clauseWording: ClauseWording | undefined) => {
  const licences: PlumbingLicence[] = [];
  if (!clauseWording?.clauseWordingLines) return licences;
  const index = clauseWording.clauseWordingLines.findIndex(
    (line) =>
      line.wording === 'PLUMBER                                                LICENCE NUMBER'
  );
  if (index === undefined || index === -1) {
    return licences;
  }

  for (let i = index + 1; i < clauseWording.clauseWordingLines.length; i += 1) {
    const { wording } = clauseWording.clauseWordingLines[i];
    if (!wording) {
      break;
    }
    const name = wording.substring(0, 30).trimEnd();
    const number = wording.substring(30).trim();
    licences.push({
      name,
      number,
    });
  }
  return licences;
};
